import { Link } from "react-router";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer bg-dark text-light ">
      {/* <div className="container">
        <div className="row">
          <div className="col-md-6 mb-4">
            <h6 className="text-uppercase fw-bold mb-3">About Us</h6>
            <p className="text-muted small">
              Khoury Private Office facilitates high-value transactions across energy, capital, technology, hospitality, and strategic investments.
            </p>
            <h5 className="fw-bold mt-4">KhouryCapital</h5>
          </div>

          <div className="col-md-6 mb-4">
            <h6 className="text-uppercase fw-bold mb-3">
              Recent Comments/Products
            </h6>
            <ul className="list-unstyled recent-comments">
              {["Latest News", "Market Insights", "Global Presence"].map(
                (item, idx) => (
                  <li key={idx} className="mb-2 border-bottom pb-2 ">
                    {item}
                  </li>
                )
              )}
            </ul>
          </div>
        </div>
      </div> */}

      {/* Bottom Bar */}
      <div className="footer-bottom bg-black py-3 mt-0">
        <div className="container d-flex justify-content-between flex-wrap align-items-center">
          <div style={{ textAlign: "center", width: "100%" }}>
            <small className="text-muted">© Copyright 2025, Khoury Capital</small>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
